import {
  linkedinLogo,
  emailLogo,
  whiteGitHubLogo,
  telegramLogo
}from '../img';

const contactData = [
  {
    name: 'Linkedin',
    link: 'https://www.linkedin.com/in/samuel-silva-melo/',
    img: linkedinLogo,
  },
  {
    name: 'Email',
    link: 'mailto:samuel.silva.melo@hotmail.com',
    img: emailLogo,
  },
  {
    name: 'GitHub',
    link: 'https://github.com/SamuelSilvaMelo',
    img: whiteGitHubLogo,
  },
  {
    name: 'Telegram',
    link: 'https://t.me/SamuelMelo',
    img: telegramLogo,
  },
];

export default contactData;
